import moment from 'moment';
import { capitalizeFirstLetter } from './globalFunction';

export function CashOutApprovalCollection(data, intl) {
    let approval = []
    if(data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            approval.push({
                id         : `${data[i].id}`,
                staffNo    : `${data[i].comp_leave_reqs.employee.staff_no}`,
                employee   : `${data[i].comp_leave_reqs.employee.employee_name}`,
                staffDuty  : capitalizeFirstLetter(data[i].comp_leave_reqs.employee.staff_duty),
                staffStatus: `${data[i].comp_leave_reqs.employee.active ? 'Active' : 'Inactive'}`,
                position   : `${data[i].comp_leave_reqs.employee.position}`,
                location   : `${data[i].comp_leave_reqs.employee.location.name}`,
                department : `${data[i].comp_leave_reqs.employee.department.name}`,
                from       : `${moment(data[i].from).format(window.global.displayDateTimeFormat)}`,
                to         : `${moment(data[i].to).format(window.global.displayDateTimeFormat)}`,
                remaining  : `${data[i].remaining}`,
            });
        }
    }
    return approval;
}

export function CashOutApprovalHistoryCollection(data, intl) {
    let approval = []
    if(data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const userData = {
                id           : `${data[i].id}`,
                staffNo      : `${data[i].staff_no}`,
                employee     : `${data[i].employee_name}`,
                staffDuty    : capitalizeFirstLetter(data[i].staff_duty),
                staffStatus  : `${data[i].staff_status ? 'Active' : 'Inactive'}`,
                position     : `${data[i].position}`,
                location     : `${data[i].location_name}`,
                department   : `${data[i].department_name}`,
                from         : `${moment(data[i].from).format(window.global.displayDateTimeFormat)}`,
                to           : `${moment(data[i].to).format(window.global.displayDateTimeFormat)}`,
                justification: `${data[i].justification}`.replace(/^[\s\n\r\t]+|[\s\n\r\t]+$/g, '').replace(/\n/g, ' ').replace(/^(\s*-\s*)+/, ''),
                remaining    : `${data[i].remaining}`,
                cutOffDate   : `${data[i].cut_off_date}`,
                dateApproved : `${moment(data[i].created_at).format(window.global.displayDateTimeFormat)}`,
            };

            approval.push(userData);
        }
    }
    return approval;
}

export function CashOutApprovalSummaryCollection(data, intl) {
    let approval = []
    if(data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const userData = {
                id         : `${data[i].id}`,
                staffNo    : `${data[i].staff_no}`,
                employee   : `${data[i].employee_name}`,
                staffDuty  : capitalizeFirstLetter(data[i].staff_duty),
                staffStatus: `${data[i].staff_status ? 'Active': 'Inactive'}`,
                position   : `${data[i].position}`,
                location   : `${data[i].location_name}`,
                department : `${data[i].department_name}`,
                totalHours : `${data[i].total_hours}`
            };

            approval.push(userData);
        }
    }
    return approval;
}